<div class="standardpanel">
  <div class="titleblock">
    <h3 class="title1level">Documentazione Allegata Fascicolo</h3>
  </div>
  <div class="container_dati_generali">
    <div class="row">
      <!--      <div class="col-sm-4">-->
      <div class="col-sm-4" style="display: none">
        <app-treeview-component [treeModel]="navigatorTreeModel"
                                [showFileDetail]="false"
                                [itemSelected]="navigatorItemSelected"
                                (onItemSelected)="updateNavigatorItemSelected($event)"
                                [refreshData]="navigatorRefreshData"
                                (setRefreshData)="updateNavigatorRefreshData($event)"
        ></app-treeview-component>
      </div>
      <!--      <div class="col-sm-8" [ngSwitch]="navigatorStateValue">-->
      <div class="col-sm-12">
        <app-detail-folder-file [minervaWizard]="true"
                                [separatorePathLogico]="navigatorPathSeparator"
                                [itemSelected]="navigatorItemSuggested"
        ></app-detail-folder-file>
      </div>
      <div class="col-sm-12" [ngSwitch]="navigatorStateValue">
        <app-detail-folder-file *ngSwitchCase="navigatorState.DETAILS"
                                [minervaWizard]="true"
                                [separatorePathLogico]="navigatorPathSeparator"
                                [itemSelected]="navigatorItemSelected"
                                (updateItemSelected)="updateNavigatorItemSelected($event)"
                                [refreshData]="navigatorRefreshData"
                                (setRefreshData)="updateNavigatorRefreshData($event)"
                                [addDocFormTitles]="navigatorAddDocFromTitle"
                                (onClickAddFolder)="onClickAddFolder($event)"
                                (onClickAddDocument)="onClickAddDocument($event)"
                                (onClickMoveDocument)="onClickMoveDocument($event)"
                                (onClickRemoveDocument)="onClickRemoveDocument($event)"
                                (from)="onDragMoveDocument($event)"
                                (to)="onDropMoveDocument($event)"
                                (onGoSectionRoot)="onGoSectionRoot($event)"
                                (onGoSectionChild)="onGoSectionChild($event)"
        ></app-detail-folder-file>
        <app-new-document-form *ngSwitchCase="navigatorState.ADD_DOCUMENT"
                               [tipiDocumento]="tipiDocumento"
                               [tipiProvenienza]="tipiProvenienza"
                               (onReturnCallback)="onAddDocument($event)"
        ></app-new-document-form>
        <app-add-folder-form *ngSwitchCase="navigatorState.ADD_FOLDER"
                             [tipiDocumento]="tipiDocumento"
                             [tipiProvenienza]="tipiProvenienza"
                             (onReturnCallback)="onAddDocument($event)"
        ></app-add-folder-form>
      </div>
    </div>
  </div>
</div>
<div class="row wizard-buttons">
  <p class="col-sm-3 col-xs-3">
    <button type="button" class="btn btn-outline-secondary btn-block" (click)="onReset()">Reset</button>
  </p>
</div>
